import AccordionBase from '../../../2compounds/AccordionBase'

const AdminEdit = ({label, index}) => {
    return (
        <AccordionBase label={label || <span>&nbsp;</span>} isOpen admin index={index}>
            <div />
        </AccordionBase>
    )
}

export default AdminEdit
